"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _TrafficSpacesGridStyles = require("../../styles/TrafficSpacesGridStyles2");

var _utils = require("../../utils");

var _TrafficSpacesRowFixed = _interopRequireDefault(require("./TrafficSpacesRowFixed2"));

var _excluded = ["rowIndex", "begin", "end", "spaces", "dateValidation", "companyFacilities"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TrafficSpacesGrid2 = function TrafficSpacesGrid2(_ref) {
  var _props$hideSortButton;

  var rowIndex = _ref.rowIndex,
      begin = _ref.begin,
      end = _ref.end,
      spaces = _ref.spaces,
      dateValidation = _ref.dateValidation,
      companyFacilities = _ref.companyFacilities,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      listHours = _useState2[0],
      setListHours = _useState2[1];

  var scrollRef = /*#__PURE__*/(0, _react.createRef)();
  var verticalScrollRef = /*#__PURE__*/(0, _react.createRef)();
  (0, _react.useEffect)(function () {
    if (begin <= end && end >= begin) {
      var times = [];

      for (var time = begin; time <= end; time += 100) {
        times.push((0, _utils.formatTime)(time));
      }

      setListHours(times); // setListHours(prev => [...prev, formatTime(time)])
    } else {
      throw new Error('Bad end and begin props');
    }
  }, [begin, end]);
  (0, _react.useEffect)(function () {
    var searched = spaces.map(function (s) {
      return s.appointments || [];
    }).flat().filter(function (a) {
      return a.searched;
    });
    var confSearched = spaces.map(function (s) {
      return s.conflicts || [];
    }).flat().map(function (c) {
      return c.orders.map(function (o) {
        return _objectSpread(_objectSpread({}, o), {}, {
          id: c.id
        });
      });
    }).flat().filter(function (o) {
      return o.searched;
    });
    var totalSearched = searched.concat(confSearched);

    if (totalSearched.length === 1) {
      if (scrollRef.current) {
        var r = document.getElementById('card-'.concat(totalSearched[0].id));

        if (r) {
          r.scrollIntoView({
            block: 'center'
          }); // console.log("ELEMENT ", r.getBoundingClientRect(), r.getBoundingClientRect().left);
          // console.log("verticalScrollRef", verticalScrollRef.current);
          // if(verticalScrollRef.current){
          //   console.log("ELEMENT TOP:", r.getBoundingClientRect().top);
          //   verticalScrollRef.current.scrollTop = r.getBoundingClientRect().top - 200;
          // }

          scrollRef.current.scrollLeft = r.getBoundingClientRect().left - 300;
          var rows = document.getElementsByClassName('scroll-test-traffic-row');
          Array.from(rows).forEach(function (a) {
            var _scrollRef$current;

            return a.scrollLeft = ((_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollLeft) || 0;
          });
        }
      }
    } else {
      var _rows = document.getElementsByClassName('scroll-test-traffic-row');

      Array.from(_rows).forEach(function (a) {
        var _scrollRef$current2;

        return a.scrollLeft = ((_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 ? void 0 : _scrollRef$current2.scrollLeft) || 0;
      });
    } // console.log("SPACES", searched, confSearched, spaces);

  }, spaces);

  var setTimetoPercent = function setTimetoPercent(value) {
    return parseInt(value / 100) * 100 + Math.min(value % 100, 59) * 100 / 60;
  };

  var getScrollWidth = function getScrollWidth() {
    if (props.scrollWidth && "".concat(props.scrollWidth).includes('px')) {
      var value = "".concat(props.scrollWidth).replace('px', '');
      return "".concat(Number(value) + 15, "px");
    } else {
      return props.scrollWidth;
    }
  };

  var hideSortButtons = (_props$hideSortButton = props.hideSortButtons) !== null && _props$hideSortButton !== void 0 ? _props$hideSortButton : false;
  return /*#__PURE__*/_react["default"].createElement(_TrafficSpacesGridStyles.Wrapper, props, /*#__PURE__*/_react["default"].createElement(_TrafficSpacesGridStyles.TimelineWrapper, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '15%'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "scroll-test-traffic-row timeline",
    style: {
      width: '85%',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/_react["default"].createElement(_TrafficSpacesGridStyles.Timeline, {
    scrollWidth: props.scrollWidth
  }, listHours.map(function (time, i) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TrafficSpacesGridStyles.TimelineCaption, {
      key: time,
      width: "".concat(100 / listHours.length, "%"),
      isCurrentTime: (0, _utils.checkCurrentHour)(time),
      className: props.selectedTime === time ? 'selected' : ''
    }, /*#__PURE__*/_react["default"].createElement("span", null, time), /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick() {
        if (props.isLoading) {
          return;
        }

        props.onSummaryClick({
          target: {
            name: 'hour',
            value: time
          }
        });
      },
      className: "summary-icon",
      style: {
        height: "15px",
        width: "15px",
        background: "#fff6",
        position: "absolute",
        right: "18px",
        borderRadius: "50%",
        top: "2px",
        cursor: props.isLoading ? "default" : "pointer",
        display: "none",
        transform: "rotate(-90deg)",
        justifyContent: "center",
        lineHeight: "8px",
        visibility: hideSortButtons ? "hidden" : "visible"
      }
    }, "..."), /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick() {
        if (props.isLoading) {
          return;
        }

        props.onHourClick({
          target: {
            name: 'hour',
            value: time
          }
        });
      },
      className: "sort-icon",
      style: {
        height: "16px",
        width: "16px",
        background: "#fff6",
        position: "absolute",
        right: "0px",
        borderRadius: "50%",
        top: "2px",
        cursor: props.isLoading ? "default" : "pointer",
        display: "none",
        visibility: hideSortButtons ? "hidden" : "visible"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: "0",
        height: "0",
        borderLeft: "6px solid transparent",
        borderRight: "6px solid transparent",
        borderBottom: "6px solid #3d4a6982",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -67%)"
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        position: "absolute",
        width: "1px",
        height: "4.5px",
        borderLeft: "2px dotted #51afec52",
        bottom: "0",
        left: "25%"
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        position: "absolute",
        width: "1px",
        height: "9px",
        borderLeft: "2px dotted #51afec52",
        bottom: "0",
        left: "50%"
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        position: "absolute",
        width: "1px",
        height: "4.5px",
        borderLeft: "2px dotted #51afec52",
        bottom: "0",
        left: "75%"
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        position: "absolute",
        height: "557px",
        zIndex: "10",
        borderLeft: "2px #51AFEC52 dashed",
        transform: "translateX(-0.2rem)",
        left: "".concat(100 / listHours.length * i, "%")
      }
    }));
  })))), /*#__PURE__*/_react["default"].createElement(_TrafficSpacesGridStyles.RowSpaceWrapper, {
    ref: props.verticalScrollRef || verticalScrollRef,
    style: {
      width: spaces.length > 5 ? "100%" : "99%"
    }
  }, companyFacilities ? companyFacilities.map(function (cF) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TrafficSpacesGridStyles.TimelineSubtitle, null, cF.name, /*#__PURE__*/_react["default"].createElement(_TrafficSpacesGridStyles.TimelineSubtitleExtra, null, cF.time)), spaces.filter(function (s) {
      return s.facility === cF.id;
    }).map(function (space, key) {
      return /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowFixed["default"], _extends({
        scrollWidth: props.scrollWidth,
        dateValidation: dateValidation,
        key: "".concat(space.id, "-").concat(key),
        range: [setTimetoPercent(begin), setTimetoPercent(end)],
        selectedTime: props.selectedTimeNumberFormat
      }, space, {
        spaceIndex: space.space_number ? space.space_number : key + 1,
        windows: space.windows.map(function (w) {
          return _objectSpread(_objectSpread({}, w), {}, {
            begin: setTimetoPercent(w.begin),
            end: setTimetoPercent(w.end),
            realBegin: setTimetoPercent(w.realBegin),
            realEnd: setTimetoPercent(w.realEnd)
          });
        }),
        appointments: space.appointments.map(function (a) {
          return _objectSpread(_objectSpread({}, a), {}, {
            begin: setTimetoPercent(a.begin),
            end: setTimetoPercent(a.end)
          });
        }),
        conflicts: space.conflicts.map(function (c) {
          return _objectSpread(_objectSpread({}, c), {}, {
            begin: setTimetoPercent(c.begin),
            end: setTimetoPercent(c.end)
          });
        })
      }));
    }));
  }) : spaces.map(function (space, key) {
    return /*#__PURE__*/_react["default"].createElement(_TrafficSpacesRowFixed["default"], _extends({
      dateValidation: dateValidation,
      key: "".concat(space.id, "-").concat(key),
      range: [setTimetoPercent(begin), setTimetoPercent(end)],
      selectedTime: props.selectedTimeNumberFormat
    }, space, {
      windows: space.windows.map(function (w) {
        return _objectSpread(_objectSpread({}, w), {}, {
          begin: setTimetoPercent(w.begin),
          end: setTimetoPercent(w.end),
          realBegin: setTimetoPercent(w.realBegin),
          realEnd: setTimetoPercent(w.realEnd)
        });
      }),
      appointments: space.appointments.map(function (a) {
        return _objectSpread(_objectSpread({}, a), {}, {
          begin: setTimetoPercent(a.begin),
          end: setTimetoPercent(a.end)
        });
      }),
      conflicts: space.conflicts.map(function (c) {
        return _objectSpread(_objectSpread({}, c), {}, {
          begin: setTimetoPercent(c.begin),
          end: setTimetoPercent(c.end)
        });
      })
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row'
      /* , position: 'absolute', bottom: '-40px'  */

    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      minWidth: '15%',
      width: '15%',
      height: '44.4px'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    ref: scrollRef,
    onScroll: function onScroll(e) {
      var r = document.getElementsByClassName('scroll-test-traffic-row');
      Array.from(r).forEach(function (a) {
        return a.scrollLeft = scrollRef.current.scrollLeft;
      });
    },
    style: {
      width: '85%',
      overflowX: 'scroll',
      position: 'absolute',
      left: '14%',
      bottom: '0',
      height: 'calc(100% - 35px)',
      borderRight: "1px dotted #ffffff33",
      borderLeft: "1px dotted #ffffff33"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: getScrollWidth() || '2000px',
      height: '30px'
    }
  }))));
};

TrafficSpacesGrid2.propTypes = {
  begin: _propTypes["default"].number,
  end: _propTypes["default"].number,
  dateValidation: _propTypes["default"].number,
  spaces: _propTypes["default"].arrayOf(_propTypes["default"].exact({
    rowIndex: _propTypes["default"].number,
    id: _propTypes["default"].number,
    range: _propTypes["default"].arrayOf(_propTypes["default"].number),
    loadManeuver: _propTypes["default"].bool,
    unloadManeuver: _propTypes["default"].bool,
    unloadLoadManeuver: _propTypes["default"].bool,
    loadManeuverIcon: _propTypes["default"].any,
    unloadManeuverIcon: _propTypes["default"].any,
    unloadLoadManeuverIcon: _propTypes["default"].any,
    windows: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      begin: _propTypes["default"].number,
      end: _propTypes["default"].number
    })),
    // begin: PropTypes.number.isRequired,
    // end: PropTypes.number.isRequired,
    available: _propTypes["default"].bool,
    className: _propTypes["default"].string,
    tags: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number,
      description: _propTypes["default"].string,
      color: _propTypes["default"].string
    })),
    appointments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number,
      icon: _propTypes["default"].any,
      expClass: _propTypes["default"].string,
      level: _propTypes["default"].number,
      begin: _propTypes["default"].number,
      end: _propTypes["default"].number,
      className: _propTypes["default"].string,
      color: _propTypes["default"].string,
      onClick: _propTypes["default"].func
    })),
    conflicts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      icon: _propTypes["default"].any,
      begin: _propTypes["default"].number,
      end: _propTypes["default"].number,
      className: _propTypes["default"].string,
      caption: _propTypes["default"].string,
      onClick: _propTypes["default"].func,
      childClick: _propTypes["default"].func,
      conflictingIds: _propTypes["default"].arrayOf(_propTypes["default"].number),
      color: _propTypes["default"].string
    }))
  }))
};
TrafficSpacesGrid2.defaultProps = {
  begin: 600,
  end: 1900,
  spaces: []
};
var _default = TrafficSpacesGrid2;
exports["default"] = _default;